/**
 * Net profit helpers.
 *
 * MT4's OrderProfit() is GROSS — it excludes swap and commission, which the
 * broker charges separately. The orders table stores all three as separate
 * columns, so any total shown to a user must add them together.
 *
 * Costs are stored as negative numbers, so netting is addition, not subtraction.
 *
 * NOTE: swap/commission are nullable. A NULL means "never captured" (orders
 * synced before the indicator sent these fields), not "zero cost" — those rows
 * report gross-as-net and understate costs until they are re-synced. A real
 * 0 is different: it is a genuine measured zero, e.g. an intraday trade that
 * never crossed the daily rollover and so was never charged swap.
 */
/** Net profit for a single order: profit + swap + commission. */
export const netProfit = (order) => (order.profit ?? 0) + (order.swap ?? 0) + (order.commission ?? 0);
/** Summed net profit across orders. Use instead of summing raw `profit`. */
export const sumNetProfit = (orders) => orders.reduce((total, order) => total + netProfit(order), 0);
/** Total cost (swap + commission) for a single order. Negative when charged. */
export const orderCost = (order) => (order.swap ?? 0) + (order.commission ?? 0);
